__turbopack_context__.v({
  "header": "Header-module-scss-module__O02QWq__header",
});
